let pictureSelected = false
const codeContainer = '#CTYHOCN-code'
const codeGroupContainer = '#group-code'
const $errorBoxShow = $('#error-messages')
let saveCroppedImage = false
let localData = {}
const maxImageSizeUploadMB = 2
const checkboxLimit = 1

// Default links, these will be overwritten when a hotel code (CTYHOCN) is chosen
let DBLinks = {
  homeUrl: 'javascript:void(0)',
  directionsUrl: 'javascript:void(0)',
  amenitiesUrl: 'javascript:void(0)'
}

function limitTextLinkChoice () {
  // Limit users to having 1 checkboxes enabled at any one time
  // Make sure selected checkboxes are enabled
  $(".checkbox-list input[type='checkbox']:checked").each(function () {
    setLinkItemInteractivity($(this), true)
  })
  // Toggle the other checkboxes appropriately
  const enable = $('.checkbox-list input:checked').length < checkboxLimit
  $(".checkbox-list input[type='checkbox']:not(:checked)").each(function () {
    setLinkItemInteractivity($(this), enable)
  })
}

function setLinkItemInteractivity ($checkbox, enable) {
  // Enable or disable link item
  const disable = !enable
  $checkbox.parents('label').toggleClass('disabled-text', disable)
  $checkbox.prop('disabled', disable)
  // Check if there are buttons associated with the checkbox and enable/disable as needed
  const $buttons = $checkbox.parent().find('.btn')
  if ($buttons.length) {
    $buttons.each(function () {
      const $button = $(this)
      $button.prop('disabled', disable)
      $button.find('input').prop('disabled', disable)
      $button.toggleClass('disabled', disable)
    })
  }
}

function datePickerInit () {
  // Init fro date pickers
  $('input.datepicker-init, .input-group.date').datepicker({
    autoclose: true,
    format: 'dd/mm/yyyy',
    todayHighlight: true,
    startDate: moment().format('DD/MM/YYYY'),
    language: i18next.language
  })
}

function getTextFromHtml (selector) {
  // Get html, encodes the value and removes html tags
  return $('<div />').html((selector.val()).replace(/(<([^>]+)>)/ig, '')).text()
}

function toMB (sizeInBytes) {
  return (sizeInBytes / (1024 * 1024)).toFixed(1)
}

function isLimitFileSizeExceeded (fileSelector, maxSize) {
  if (fileSelector.length && toMB(fileSelector[0].size) > maxSize) {
    return true
  }
  return false
}

function updateButtonText ($buttonText, oldText, newText) {
  if ($buttonText.text().trim() === oldText) {
    $buttonText.html(newText)
  }
}

function getFileRootName (str) {
  const parts = str.split('-')
  return parts.length > 2 ? parts.slice(0, -2).join('-') : str
}

function setImageLibrarySelection (imageRootName) {
  $('.image-library .lib-selection .image-container').removeClass('selected')
  $('.image-library .lib-selection .image-container img[data-filename^="' + imageRootName + '"]')
    .parent().addClass('selected')
}

function validateBuilder () {
  const errors = []

  const cityCode = $('#CTYHOCN-code').val()
  if (cityCode === '' || cityCode === i18next.t('builder_ctyhocn_placeholder')) {
    errors.push(i18next.t('builder_error_ctyhocn'))
  }

  const groupCode = $('#group-code').val()
  if (groupCode === '') {
    errors.push(i18next.t('builder_error_group_code'))
  }

  const validDate = /^\d{2}\/\d{2}\/\d{4}$/
  const fromDate = $('#event-from').val()
  const toDate = $('#event-to').val()
  if (!validDate.test(fromDate)) {
    errors.push(i18next.t('builder_error_start_date'))
  }
  if (!validDate.test(toDate)) {
    errors.push(i18next.t('builder_error_end_date'))
  }
  const dateFormat = 'DD/MM/YYYY'
  const dateDiff = moment(fromDate, dateFormat).diff(moment(toDate, dateFormat))
  // make sure the end date is the same as or greater than the start date
  if (dateDiff > 0) {
    errors.push(i18next.t('builder_error_dates_conflict'))
  }

  // Check the biggest picture
  const headerImage = $('#header-image-base64-top').val().replace(/^data:image\/[^;]+;base64,/, '')
  const imageStats = [
    {
      size: headerImage.length * 0.75
    }
  ]
  if (isLimitFileSizeExceeded(imageStats, maxImageSizeUploadMB)) {
    errors.push(i18next.t('builder_error_header_upload_limit', { maxImageSizeUploadMB }))
  }

  const $headerMessage = $('#header-message')
  const headerCharLimit = 100
  const headerMessageText = getTextFromHtml($headerMessage)
  if (headerMessageText.length > headerCharLimit) {
    errors.push(i18next.t('builder_error_header_max_chars', { headerCharLimit }))
  } else if (headerMessageText === i18next.t('email_default_header_message')) {
    errors.push(i18next.t('builder_error_header_placeholder'))
  }

  const $customMessage = $('#custom-message')
  const customCharLimit = 1000
  const customMessageText = getTextFromHtml($customMessage)
  if (customMessageText.length > customCharLimit) {
    errors.push(i18next.t('builder_error_custom_message_chars', { customCharLimit }))
  } else if (customMessageText === i18next.t('email_main_text')) {
    errors.push(i18next.t('builder_error_custom_message_placeholder'))
  }

  const $additionalInfo = $('#additional-info')
  const additionalInfoText = getTextFromHtml($additionalInfo)
  if (additionalInfoText.length > customCharLimit) {
    errors.push(i18next.t('builder_error_additional_info_chars', { customCharLimit }))
  } else if (additionalInfoText === i18next.t('email_additional_info')) {
    errors.push(i18next.t('builder_error_additional_info_placeholder'))
  }

  const $checkboxes = $('.checkbox-list input:checked')
  if ($checkboxes.length > checkboxLimit) {
    errors.push(i18next.t('builder_error_text_links', { checkboxLimit }))
  }

  return errors
}

function builderAjax () {
  $('#email-details').ajaxForm({
    beforeSerialize: function () {
      const $submitBtn = $('#email-details button[type="submit"]')
      $submitBtn.prop('disabled', true)
      $submitBtn.addClass('loading')
      const errors = validateBuilder()
      const $errorBox = $('#error-messages')
      if (errors.length === 0) {
        $errorBox.hide()
        return true
      }

      $submitBtn.prop('disabled', false)
      $submitBtn.removeClass('loading')
      $errorBox.html(errors.join('<br>'))
      $errorBox.slideDown()

      return false
    },
    url: '/builder/save',
    cache: false,
    dataType: 'text',
    success: function (data) {
      const $submitBtn = $('#email-details button[type="submit"]')
      $submitBtn.prop('disabled', false)
      $submitBtn.removeClass('loading')
      const $errorBox = $('#error-messages')
      let errorText = ''
      try {
        const response = JSON.parse(data)
        if (response.success) {
          window.location.href = '/emailer/' + response.emailId
          return
        }

        if (response.error) {
          errorText = response.error.replace(/,/g, '<br>')
        }
      } catch (e) {
        errorText = i18next.t('catch_all_error')
      }
      $errorBox.html(errorText).slideDown()
    },
    error: function (jqXHR) {
      const $submitBtn = $('#email-details button[type="submit"]')
      $submitBtn.prop('disabled', false)
      $submitBtn.removeClass('loading')
      const $errorBox = $('#error-messages')
      let errorText = jqXHR.responseText
      try {
        const json = JSON.parse(errorText)
        if (json.error) {
          errorText = json.error.replace(/,/g, '<br>')
        }
      } catch (e) {
        if ($('#more-information-upload').val()) {
          errorText = i18next.t('builder_error_more_info_file', { maxFileSizeMB: maxImageSizeUploadMB })
        } else {
          errorText = i18next.t('builder_error_header_image', { maxFileSizeMB: maxImageSizeUploadMB })
        }
      }
      $errorBox.html(errorText).slideDown()
    }
  })
}

function initTooltips () {
  // Initialise tooltips
  $('[data-toggle="tooltip"]').tooltip()
}

function previewInit () {
  // Check page contains a preview and if it does run the preview init
  const $preview = $('.preview-container')
  if ($preview.length) {
    // Create default data
    localData = {
      urlDomain: '',
      _id: '',
      hotelInfo: {
        usename: i18next.t('email_hotel_name_placeholder'),
        addr1: i18next.t('email_hotel_address_placeholder'),
        city: i18next.t('email_hotel_city_placeholder'),
        zip: i18next.t('email_hotel_zip_placeholder'),
        country: i18next.t('email_hotel_country_placeholder'),
        phone: i18next.t('email_hotel_phone_placeholder')
      },
      bannerType: 'library',
      banerImg: '',
      banerImgInfo: '',
      banerImgLib: 'default-image-1',
      headerText: '',
      eventDate: {
        from: '00/00/0000',
        to: '00/00/0000'
      },
      bookButton: {
        title: i18next.t('email_book_now'),
        url: bookingLinkMaker({ cityCode: '', groupCode: '' }, { from: '00/00/0000', to: '00/00/0000' })
      },
      mainText: '',
      links: [
        makeHotelLink()
      ],
      banners: defaultBannerLinks(),
      termsConditions: '',
      facebookLink: '',
      language: getLangCode(),
      fileUploaded: ''
    }

    // Get templateId
    const templateId = $('#templateId').val()
    // Get and load template data
    getTemplateData(templateId, function () {
      // CAll CKEditor init
      ckEditorInit()
    })
    // Show or hidde second banner link and uploader
    showSecondBannerInputs()

    setImageLibrarySelection(localData.banerImgLib)
  }
}

function defaultBannerLinks () {
  const defaultBanner = 'hhonors'
  const defaultSecondBanner = 'default'
  const banners = [
    {
      link: i18next.t('builder_first_banner_link_url'),
      name: defaultBanner
    },
    {
      link: i18next.t('builder_second_banner_link_url'),
      name: defaultSecondBanner
    }
  ]
  return banners
}

function makeHotelLink () {
  const link = {
    id: 'hotel-details',
    title: i18next.t('email_hotel_details'),
    url: DBLinks.homeUrl
  }
  return link
}

function reloadLink ($input) {
  const name = $input.attr('name')
  const code = {
    cityCode: $(codeContainer).val(),
    groupCode: $(codeGroupContainer).val()
  }
  let title = $input.parent().text()
  if ($input.attr('id') === 'more-information') {
    title = i18next.t('email_more_info')
  }
  const newLink = {
    id: name,
    title,
    url: generalLinkMaker(name, code, localData.eventDate)
  }
  // Add link
  localData.links.push(newLink)
}

function reloadLinks () {
  // Remove links
  localData.links = []
  // Add hotel details link
  localData.links.push(makeHotelLink())
  // Reload Links
  $('.checkbox-list input[type=checkbox]:checked').each(function () {
    reloadLink($(this))
  })
  // Update booking link
  const cityCode = $(codeContainer).val()
  const groupCode = $(codeGroupContainer).val()
  localData.bookButton.url = bookingLinkMaker({
    cityCode,
    groupCode
  }, localData.eventDate)
}

function bookingLinkMaker (code, date) {
  const langCode = getLangCode()
  const cityCode = code.cityCode
  const groupCode = code.groupCode
  const fromDate = moment(date.from, [
    'DD MMM YYYY',
    'DD/MM/YYYY'
  ])
  const toDate = moment(date.to, [
    'DD MMM YYYY',
    'DD/MM/YYYY'
  ])

  // Format date
  let eventDates = '&arrivalDate=' + fromDate.format('YYYY-MM-DD')
  eventDates += '&departureDate=' + toDate.format('YYYY-MM-DD')

  // Construct UrL
  let url = 'https://www.hilton.com/' + langCode + '/book/reservation/deeplink?'
  url += 'ctyhocn=' + cityCode + eventDates + '&groupCode=' + groupCode + '&fromId=HILTONLINKDIRECT'

  return url
}

function generalLinkMaker (type, code, date) {
  if (type === 'maps-directions') {
    return DBLinks.directionsUrl
  } else if (type === 'amenities-services') {
    return DBLinks.amenitiesUrl
  } else if (type === 'more-information') {
    const url = $('#more-information-upload-url').val()
    // If it comes from a saved file, then show the file url
    if (url !== '') {
      return url
    }
    return '#'
  }
  return '#'
}

function reloadTemplate (data) {
  const $preview = $('.preview-container')
  // Reload templates just if preview-container class exists
  if ($preview.length) {
    // Get html from the template
    const html = window.app.templates.email_preview(data)
    // Show the preview email
    $preview.empty().append(html)
    // Reload picture if already selected
    if (pictureSelected) {
      reloadImages()
    }
  }
}

function showSecondBannerInputs () {
  const showOptions = $('#banner-code').val() !== 'default'
  $('.banner-code-options').toggle(showOptions)
}

function toggleSecondBannerOptions () {
  // Hide all but the main dropdown (.second-banner-options)
  $('.banner-code-options > div:not(.second-banner-options)').hide()
  // Show correct input based or radio button selection
  const selected = $('input:radio[name=banner-code-options-radio]:checked').val()
  $('.' + selected).show()
  if (selected === 'second-banner-link') {
    $('#more-information-upload').val('')
    updateButtonText($('#more-information-btn-txt'), i18next.t('builder_text_links_upload_button_2'), i18next.t('builder_text_links_upload_button_1'))
  }
  if (selected === 'more-information-upload') {
    $('#second-banner-link').val('')
  }
}

function populateForm (data) {
  let defaultSecondBanner = 'default'
  let defaultLinkSecondBanner = 'http://www.explore.hilton.com'
  $('#CTYHOCN-code').val(data.ctyhocn)
  $('#group-code').val(data.groupCode)
  $('#event-from').val(data.eventDate.from)
  $('#event-to').val(data.eventDate.to)
  $('#header-image-url').val(data.banerImg)
  updateButtonText($('#header-image-btn-txt'), i18next.t('builder_header_image_button_1'), i18next.t('builder_header_image_button_2'))
  $('#header-image-type').val(data.bannerType)
  $('#header-image-lib').val(data.banerImgLib)
  setImageLibrarySelection(data.banerImgLib)
  $('#header-message').val(data.headerText)
  $('#custom-message').val(data.mainText)
  $(".checkbox-list input[type='checkbox']").prop('checked', false)
  $.each(data.links, function (index, value) {
    $('#' + value.id).prop('checked', true)
  })
  $('#maps-directions').change()
  $('#additional-info').val(data.termsConditions)
  $('#facebook-link').val(data.facebookLink)
  // Backwards compatibility
  if (data.banners[1].name !== undefined) {
    defaultSecondBanner = data.banners[1].name
  }
  if (data.banners[1].text !== undefined) {
    defaultLinkSecondBanner = data.banners[1].text
  }
  if (data.banners[1].link !== undefined) {
    defaultLinkSecondBanner = data.banners[1].link
  }
  $('#banner-code').val(defaultSecondBanner)
  // Show or hidde second banner link and uploader
  showSecondBannerInputs()
  // Update url if a file upload was provided
  if (data.fileUploaded) {
    $('input:radio[name=banner-code-options-radio][value=more-information-upload]').prop('checked', true)
    $('#more-information-upload-url').val(data.fileUploaded)
    updateButtonText($('#more-information-btn-txt'), i18next.t('builder_text_links_upload_button_1'), i18next.t('builder_text_links_upload_button_2'))
  } else {
    $('input:radio[name=banner-code-options-radio][value=second-banner-link]').prop('checked', true)
    // If not, then use the second banner link
    $('#second-banner-link').val(defaultLinkSecondBanner)
  }
  toggleSecondBannerOptions()
}

function getTemplateData (id, callback) {
  if (id) {
    $.ajax({
      url: '/getTemplateData/' + id,
      method: 'GET',
      async: true,
      cache: false,
      contentType: false,
      processData: false
    })
      .done(function (data) {
        if (data) {
          // Override the default data
          localData = data
          const dl = data.links
          for (let i = 0; i < dl.length; i++) {
            if (dl[i].id === 'hotel-details') {
              DBLinks.homeUrl = dl[i].url
            } else if (dl[i].id === 'maps-directions') {
              DBLinks.directionsUrl = dl[i].url
            } else if (dl[i].id === 'amenities-services') {
              DBLinks.amenitiesUrl = dl[i].url
            }
          }
          populateForm(data)
        }
      })
      .fail(function (jqXHR) {
        $errorBoxShow.html(jqXHR.responseText || i18next.t('catch_all_error')).slideDown()
      })
      .always(function () {
        // When the page load, render the template with the default data or the real data
        reloadTemplate(localData)
        // Continue ckEditor Init
        callback()
      })
  } else {
    // Reload Links
    reloadLinks()
    // When the page load, render the template with the default data
    reloadTemplate(localData)
    // Continue ckEditor Init
    callback()
  }
}

function checkLimits (obj) {
  if (obj.data.keyCode === 8 || obj.data.keyCode === 46) {
    return true
  }
  if (obj.editor.document.getBody().getText().length >= obj.editor.config.maxLength) {
    obj.data.domEvent.preventDefault()
  }
}

function textareaUpdate (editor, textBlockField, textBlockId, dataName) {
  localData[dataName] = editor.getData()
  // Update text box in builder panel
  $('#' + textBlockField).val(localData[dataName])
  // Update email preview
  const $textBlock = $('#' + textBlockId)
  if ($textBlock.length && localData[dataName] !== '') {
    // If the text block exists and there is data then update it.
    $textBlock.html(localData[dataName])
  } else {
    // If it doesn't exist or there is no data re-render the template.
    // This is because the block has padding and we don't want to render it if there is no data
    // We also don't want to render the template on every keypress as this causes performance issues on IE
    reloadTemplate(localData)
  }
}

function ckEditorInit () {
  // TextAreas
  const headerMessageField = 'header-message'
  const customMessageField = 'custom-message'
  const additionalInfoField = 'additional-info'

  // Maximum characters
  const maxHeader = 100
  const maxCustomTerms = 1000

  // General options for editors config
  const mainConfig = {
    extraPlugins: 'charcount',
    maxLength: 0,
    removePlugins: 'colorbutton',
    language: i18next.language
  }

  // Specific options for editors config
  const headerConfig = $.extend({}, mainConfig)
  headerConfig.maxLength = maxHeader
  headerConfig.removePlugins = mainConfig.removePlugins + ',basicstyles,link'
  const customConfig = $.extend({}, mainConfig)
  customConfig.maxLength = maxCustomTerms
  const additionalInfoConfig = $.extend({}, mainConfig)
  additionalInfoConfig.maxLength = maxCustomTerms

  // Replace CKEditor on header message, custom message and additional info textareas
  const headerEditor = window.CKEDITOR.replace(headerMessageField, headerConfig)
  const customEditor = window.CKEDITOR.replace(customMessageField, customConfig)
  const additionalInfoEditor = window.CKEDITOR.replace(additionalInfoField, additionalInfoConfig)

  // Disable non-breaking space entity
  window.CKEDITOR.config.fillEmptyBlocks = false

  // Check limits for header message editor
  headerEditor.on('key', function (obj) {
    checkLimits(obj)
  })

  // Check limits for custom message editor
  customEditor.on('key', function (obj) {
    checkLimits(obj)
  })

  // Check limits for additional info editor
  additionalInfoEditor.on('key', function (obj) {
    checkLimits(obj)
  })

  // Populate placeholder text via CKEditor on init
  headerEditor.on('instanceReady', function () {
    if (!this.getData()) {
      this.setData(i18next.t('email_default_header_message'))
      localData.headerText = this.getData()
      reloadTemplate(localData)
    }
  })

  customEditor.on('instanceReady', function () {
    if (!this.getData()) {
      this.setData(i18next.t('email_main_text'))
      localData.mainText = this.getData()
      reloadTemplate(localData)
    }
  })

  additionalInfoEditor.on('instanceReady', function () {
    if (!this.getData()) {
      this.setData(i18next.t('email_additional_info'))
      localData.termsConditions = this.getData()
      reloadTemplate(localData)
    }
  })

  // Update values on change
  headerEditor.on('change', function () {
    textareaUpdate(this, headerMessageField, 'edit-header-text', 'headerText')
  })

  customEditor.on('change', function () {
    textareaUpdate(this, customMessageField, 'edit-custom-text', 'mainText')
  })

  additionalInfoEditor.on('change', function () {
    textareaUpdate(this, additionalInfoField, 'edit-additional-info', 'termsConditions')
  })
}

function clearUploadInput () {
  // This was originally $('#header-image').val('') however that did not work in IE10 as
  // file upload inputs are read only (even for clearing the value)
  const value = document.getElementById('header-image').parentNode.innerHTML
  document.getElementById('header-image').parentNode.innerHTML = value
}

function openCropper (imageUrl) {
  $('#cropper-image-preview').attr('src', imageUrl)
  $('#cropperModal').modal('show')
}

function processImage (imageData, callback) {
  const image = new Image()
  const canvas = document.createElement('canvas')
  const width = 600
  const height = 300

  canvas.width = width
  canvas.height = height

  image.onload = function () {
    const ctx = canvas.getContext('2d')
    ctx.drawImage(image, 0, 0, width, height)

    const type = config.headerImages.type // Should match backend
    const quality = config.headerImages.quality // between 0 and 1

    const obj = {
      top: canvas.toDataURL(type, quality)
    }

    callback(null, obj)
  }

  image.src = imageData
}

function reloadImages (imagesData) {
  // If no imagesData provided, load the ones already loaded
  if (!imagesData) {
    imagesData = {
      top: $('#header-image-base64-top').val()
    }
  }
  // Assign base64 data to image src
  $('.banerImgTemplate img').attr('src', imagesData.top)
  localData.banerImg = imagesData.top
}

function initInputListeners () {
  $(document).on('change', '#CTYHOCN-code', function () {
    const code = $(this).val()
    $.ajax({
      url: '/getHotelInfo/' + code,
      type: 'GET',
      async: true,
      cache: false,
      contentType: false,
      processData: false,
      success: function (data) {
        if (data) {
          localData.hotelInfo = {
            usename: data.innName,
            addr1: data.addrLine1,
            city: data.addrCity,
            zip: data.zipCode,
            country: data.country,
            phone: data.phone
          }
          DBLinks = {
            homeUrl: data.homeUrl,
            directionsUrl: data.directionsUrl,
            amenitiesUrl: data.amenitiesUrl
          }
          reloadLinks()
          reloadTemplate(localData)
        }
      }
    })
  })

  $('#btn-close-cropper').click(function () {
    saveCroppedImage = false
    $('#cropperModal').modal('hide')
  })

  $('#btn-save-cropper').click(function () {
    saveCroppedImage = true
    $('#cropperModal').modal('hide')
  })

  // Cropper on close event, used to process cropped image.
  $('#cropperModal').on('hidden.bs.modal', function () {
    const $image = $('#cropper-image-preview')
    // If the user clicked save not cancel
    if (saveCroppedImage) {
      const type = config.headerImages.type // Should match backend
      const quality = config.headerImages.quality // between 0 and 1
      const dimensions = {
        width: 600,
        height: 300
      }
      const imageData = $image.cropper('getCroppedCanvas', dimensions).toDataURL(type, quality)
      // Carve up image
      return processImage(imageData, function (err, imagesData) {
        if (err) {
          console.log('Issue processing image', err)
          return
        }

        // Reload images on each img tag
        reloadImages(imagesData)

        saveCroppedImage = false
        pictureSelected = true

        // Save image data
        $('#header-image-base64-top').val(imagesData.top)
        $('#header-image-type').val('upload').change()

        // Save image name
        let filename = $('#header-image').val()
        filename = filename.split(/(\\|\/)/g).pop()
        $('#header-image-name').val(filename)

        // Cleanup
        clearUploadInput()
        $image.cropper('destroy')
      })
    }
    // Cleanup
    clearUploadInput()
    $image.cropper('destroy')
  })

  // Cropper settings
  $('#cropperModal').on('shown.bs.modal', function () {
    const $image = $('#cropper-image-preview')
    $image.cropper({
      aspectRatio: 600 / 300,
      autoCropArea: 1
    })
  })

  $(document).on('change', '.second-banner-options input:radio', toggleSecondBannerOptions)

  $(document).on('keyup', '#second-banner-link', function () {
    const $moreInformationUploadUrl = $('#more-information-upload-url')
    // When a link is provided disable more information button
    // Remove old link from localData
    localData.fileUploaded = ''
    // Clear out old upload url
    $moreInformationUploadUrl.val('')
    // Update second banner link
    localData.banners[1].link = $(this).val()
    // Reload template
    reloadTemplate(localData)
  })

  $(document).on('change', '#more-information-upload', function () {
    const file = this.files[0]
    if (file && file.size > maxImageSizeUploadMB * 1024 * 1024) {
      alert(i18next.t('builder_error_more_info_file', { maxFileSizeMB: maxImageSizeUploadMB }))
      $(this).val('')
      return
    }
    // Update second banner link with no link
    localData.banners[1].link = ''
    // Clear out second baner link
    const $secondBannerLink = $('#second-banner-link')
    $secondBannerLink.val('')
    // Reload template
    reloadTemplate(localData)
  })

  $(document).on('change', '#header-image', function () {
    const file = this.files[0]
    if (file && file.size > maxImageSizeUploadMB * 1024 * 1024) {
      alert(i18next.t('builder_error_header_image', { maxFileSizeMB: maxImageSizeUploadMB }))
      clearUploadInput()
      return
    }
    $('#email-details').ajaxSubmit({
      url: '/builder/image/save',
      cache: false,
      dataType: 'text',
      success: function (data) {
        let errorText = ''
        try {
          const response = JSON.parse(data)
          if (response.success) {
            return openCropper(response.base64)
          }
          if (response.error) {
            errorText = response.error.replace(/,/g, '<br>')
          }
        } catch (e) {
          errorText = i18next.t('catch_all_error')
        }
        alert(errorText)
      },
      error: function (jqXHR) {
        let errorText = ''
        try {
          const json = JSON.parse(jqXHR.responseText)
          if (json.error) {
            errorText = json.error.replace(/,/g, '\n')
          }
        } catch (e) {
          errorText = i18next.t('builder_error_header_image', { maxFileSizeMB: maxImageSizeUploadMB })
        }
        alert(errorText)
      }
    })
    return false
  })

  $(document).on('keyup', '#group-code', function () {
    // Reload links
    reloadLinks()
    // Reload template
    reloadTemplate(localData)
  })

  $(document).on('change', '#event-from', function () {
    localData.eventDate.from = $(this).val()
    // Reload links
    reloadLinks()
    // Reload template
    reloadTemplate(localData)
  })

  $(document).on('change', '#event-to', function () {
    localData.eventDate.to = $(this).val()
    // Reload links
    reloadLinks()
    // Reload template
    reloadTemplate(localData)
  })

  $(document).on('change', 'input[type="checkbox"]', function () {
    // Reload Links
    reloadLinks()
    // Reload template
    reloadTemplate(localData)
  })

  $(document).on('keyup', '#facebook-link', function () {
    localData.facebookLink = $(this).val()
    // Reload template
    reloadTemplate(localData)
  })

  $(document).on('change', '#facebook-link', function () {
    const uri = $(this).val()
    if (uri === '') {
      return
    }
    // Check that URI is a URL, if it is not add the http:// prefix and update the form.
    if (uri.indexOf('http://') === -1 && uri.indexOf('https://') === -1) {
      const url = 'http://' + uri
      $(this).val(url)
      localData.facebookLink = url
    }
  })

  $(document).on('change', '#banner-code', function () {
    localData.banners[1].name = $(this).val()
    // Clear out banner link input
    $('#second-banner-link').val('')
    // Clear out file input
    $('#more-information-upload').val('')
    // Clear out file input url
    $('#more-information-upload-url').val('')
    // Change button name for the default one
    $('#more-information-btn-txt').html(i18next.t('builder_text_links_upload_button_1'))
    // Show inputs depending on the second banner
    showSecondBannerInputs()
    toggleSecondBannerOptions()
    // Reload template
    reloadTemplate(localData)
  })

  $(document).on('change', '#header-image-btn :file', function () {
    const $button = $(this).parent().find('#header-image-btn-txt')
    updateButtonText($button, i18next.t('builder_header_image_button_1'), i18next.t('builder_header_image_button_2'))
  })

  $(document).on('change', '#more-information-btn :file', function () {
    const $button = $(this).parent().find('#more-information-btn-txt')
    updateButtonText($button, i18next.t('builder_text_links_upload_button_1'), i18next.t('builder_text_links_upload_button_2'))
  })

  $(document).on('click', '#header-image-library-btn', function () {
    $('#imageLibraryModal').modal('show')
  })

  $(document).on('click', '.image-library .image-container', function () {
    $(this).siblings().removeClass('selected')
    $(this).addClass('selected')
  })

  $(document).on('click', '#btn-close-image-library', function () {
    $('#imageLibraryModal').modal('hide')
  })

  $(document).on('click', '#btn-save-image-library', function () {
    const filename = $('.image-library .lib-selection .image-container.selected img').data('filename')
    $('#header-image-lib').val(getFileRootName(filename)).change()
    $('#header-image-type').val('library').change()
    $('#imageLibraryModal').modal('hide')
  })

  $(document).on('change', '#header-image-lib', function () {
    const imageRootName = $(this).val()
    localData.banerImgLib = imageRootName
    setImageLibrarySelection(imageRootName)
    reloadTemplate(localData)
  })

  $(document).on('change', '#header-image-type', function () {
    const imageType = $(this).val()
    localData.bannerType = imageType
    if (imageType !== 'upload') {
      pictureSelected = false
      localData.banerImg = ''
    }
    reloadTemplate(localData)
  })

  // Trigger limitTextLinkChoice when ever a checkbox is checked or unchecked
  $(".checkbox-list input[type='checkbox']").change(limitTextLinkChoice)

  $('.booking-builder.preview-container').click(function (e) {
    e.preventDefault()
  })
}

// eslint-disable-next-line no-unused-vars
function builderInit () {
  moment.locale(i18next.language)
  datePickerInit()
  previewInit()
  initInputListeners()
  initTooltips()
  builderAjax()
  limitTextLinkChoice()
}
